import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M9.96009 47.65C14.0901 43.69 11.9401 36.75 11.9401 36.75C15.2401 30.31 11.7701 26.84 11.7701 26.84C15.9001 20.4 12.1 15.61 12.1 15.61C16.39 9.66996 11.9301 3.71998 11.9301 3.71998C11.9301 3.71998 6.9201 -0.600015 3.0901 3.78998C3.0901 3.78998 -0.869914 10.08 3.89009 15.65C3.89009 15.65 0.490076 20.73 5.13008 26.82C5.13008 26.82 1.96009 30.56 5.77009 36.71C5.77009 36.71 4.19008 43.8 8.63008 47.41L9.96009 47.65Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M39.2599 47.65C35.1299 43.69 37.28 36.75 37.28 36.75C33.98 30.31 37.4499 26.84 37.4499 26.84C33.3199 20.4 37.1199 15.61 37.1199 15.61C32.8299 9.66996 37.2899 3.71998 37.2899 3.71998C37.2899 3.71998 42.2999 -0.600015 46.1299 3.78998C46.1299 3.78998 50.0899 10.08 45.3299 15.65C45.3299 15.65 48.73 20.73 44.09 26.82C44.09 26.82 47.2599 30.56 43.4499 36.71C43.4499 36.71 45.03 43.8 40.59 47.41L39.2599 47.65Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
